var map = {
	"./a_64k.mp3": 19,
	"./e_64k.mp3": 20,
	"./i_64k.mp3": 21,
	"./o_64k.mp3": 22,
	"./u_64k.mp3": 23,
	"./ā_64k.mp3": 24,
	"./ē_64k.mp3": 25,
	"./ī_64k.mp3": 26,
	"./ō_64k.mp3": 27,
	"./ū_64k.mp3": 28
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;